export default {
  chat: (state) => state.chat,
  threadId: (state) => state.threadId,
  loading: (state) => state.loading,
  chatHistory: (state) => state.chatHistory,
  historyLoading: (state) => state.historyLoading,
};
